import axios from "axios";
import { __constants } from "../constants";
import { apiResponse } from "../utils";
const BASE_URL = process.env.REACT_APP_SERVER_URL;

export const getEditSKProfile = async (_id) => {
    try {
        const config = {
            method: 'get',
            url: BASE_URL + "/v1/admin/user-management/sk-moreInfo/" + _id,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            }
        };
        const response = await axios(config);

        /* Handle logic for API response */
        if (response.data.status === 200) {
            let needs = [], responseNeed = response.data.data.seeker.length > 0 && response.data.data.seeker[0].needs.length > 0
            let lookingFor = [
                {
                    name: "Housekeeper",
                    orgName :"HouseKeeper",
                    isMarked: response.data.data.seeker[0]?.lookingFor?.includes("HouseKeeper")
                },
                {
                    name: "Babysitter",
                    orgName :"BabySitter",
                    isMarked: response.data.data.seeker[0]?.lookingFor?.includes("BabySitter")
                }
            ]

            let cleaningProducts =  response.data.data.seeker[0]?.cleaningProducts[0], cleaningEquipments = response.data.data.seeker[0]?.cleaningEquipments[0]

            response.data.data.moreInfo.basicDetail.forEach((outElem) => {
                if (responseNeed && response.data.data.seeker[0].needs[0].some((innerElem) => innerElem.name === outElem.name)) {
                    needs.push({
                        _id: outElem._id,
                        isMarked: true,
                        name: outElem.name
                    })
                } else {
                    needs.push({
                        _id: outElem._id,
                        isMarked: false,
                        name: outElem.name
                    })
                }
            })
            
            return apiResponse({ data: { needs,lookingFor,cleaningProducts,cleaningEquipments, userInfo: response.data.data.seeker.length > 0 ? response.data.data.seeker[0] : {}, langugages: response.data.data.moreInfo.countryLanguages } })
        } else {
            return apiResponse({
                error: response.data.errors,
                status: response.data.status
            })
        }

    } catch (err) {
        return apiResponse({
            error: err.response,
            status: 500,
            message: "Something went wrong"
        })
    }
}

export const getEditHKProfile = async (_id) => {
    try {
        const config = {
            method: 'get',
            url: BASE_URL + "/v1/admin/user-management/hk-moreInfo/" + _id,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            }
        };

        const response = await axios(config);

        if (response.data.status === 200) { /* Handle logic for API response */
            let frAvailableFor = [],
                frInterestedFor = [],
                experience = [],
                availableFor = [],
                interestedFor = [],
                check;

            response.data.data.preUserDetails.basicDetail.forEach((object) => {  /* format available/interested for */
                if (object.type === "availableForHouseKeeper") frAvailableFor = object.data
                else if (object.type === "interestedForHouseKeeper") frInterestedFor = object.data
            })

            const hk = response.data.data.houseKeeper?.[0] || {};
                    
            const availableForData = hk.availableFor?.[0] || [];
            const interestedForData = hk.interestedFor?.[0] || [];
                    
            frAvailableFor.forEach((outElem) => {
                const isMarked = availableForData.some((innerElem) => innerElem.name === outElem.name);
                availableFor.push({
                    _id: outElem._id,
                    isMarked,
                    name: outElem.name
                });
            });
            
            frInterestedFor.forEach((outElem) => {
                const isMarked = interestedForData.some((innerElem) => innerElem.name === outElem.name);
                interestedFor.push({
                    _id: outElem._id,
                    isMarked,
                    name: outElem.name
                });
            });

            check = response.data.data.houseKeeper.length > 0
            response.data.data.preUserDetails.experience.forEach((outElem) => { /* Experience */
                if (check && response.data.data.houseKeeper[0].experience.some((innerElem) => innerElem.from === outElem.from && innerElem.to === outElem.to)) {
                    experience.push({
                        _id: outElem._id,
                        isMarked: true,
                        from: outElem.from,
                        to: outElem.to
                    })
                } else if (check) {
                    experience.push({
                        _id: outElem._id,
                        isMarked: false,
                        from: outElem.from,
                        to: outElem.to
                    })
                }
            })

            return apiResponse({ data: { availableFor, interestedFor, experience, languages: response.data.data.preUserDetails.countryLanguages, userInfo: response.data.data.houseKeeper.length > 0 ? response.data.data.houseKeeper[0] : {} } })
        } else {
            return apiResponse({
                error: response.data.errors,
                status: response.data.status
            })
        }
    } catch (err) {
        return apiResponse({
            error: err.response,
            status: 500,
            message: "Something went wrong"
        })
    }
}

export const getEditBSProfile = async (_id) => {
  try {
    const config = {
      method: 'get',
      url: BASE_URL + "/v1/admin/user-management/bs-moreInfo/" + _id,
      headers: {
        'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
      }
    };
    const response = await axios(config);

    if (response.data.status === 200) {
      const bs = response.data.data.babysitter?.[0] || {};
      const pre = response.data.data.preUserDetails;

      const frAvailableForBabyCare = pre.basicDetail.find(d => d.type === "availableForBabyCare")?.data || [];
      const frInterestedForBabyCare = pre.basicDetail.find(d => d.type === "interestedForBabyCare")?.data || [];
      const frSpecialityForBabyCare = pre.basicDetail.find(d => d.type === "specialityForBabyCare")?.data || [];
      const frChildRangeExperience = pre.basicDetail.find(d => d.type === "childRangeExperience")?.data || [];
      const frIHaveForBabyCare = pre.basicDetail.find(d => d.type === "IHaveForBabyCare")?.data || [];
      const frExperience = pre.experience || [];

      const markMatched = (frList, bsList = []) =>
        frList.map(outElem => ({
          _id: outElem._id,
          name: outElem.name,
          isMarked: bsList.some(inner => inner.name === outElem.name)
        }));

      const markExperience = (frList, bsList = []) =>
        frList.map(outElem => ({
          _id: outElem._id,
          from: outElem.from,
          to: outElem.to,
          isMarked: bsList.some(inner => inner.from === outElem.from && inner.to === outElem.to)
        }));

      const availableForBabyCare = markMatched(frAvailableForBabyCare, bs.availableForBabyCare);
      const interestedForBabyCare = markMatched(frInterestedForBabyCare, bs.interestedForBabyCare);
      const specialityForBabyCare = markMatched(frSpecialityForBabyCare, bs.speciality);
      const childRangeExperience = markMatched(frChildRangeExperience, bs.childRangeExperience);
      const iHaveForBabyCare = markMatched(frIHaveForBabyCare, bs.IHaveForBabyCare);
      const experience = markExperience(frExperience, bs.experience);

      return apiResponse({
        data: {
          availableForBabyCare,
          interestedForBabyCare,
          specialityForBabyCare,
          childRangeExperience,
          iHaveForBabyCare,
          experience,
          languages: pre.countryLanguages,
          userInfo: bs
        }
      });

    } else {
      return apiResponse({
        error: response.data.errors,
        status: response.data.status
      });
    }

  } catch (err) {
    return apiResponse({
      error: err,
      status: 500,
      message: "Something went wrong"
    });
  }
}


export const saveUserProfile = async (role, _id, data) => {
    try {
        const config = {
            method: 'put',
            url: BASE_URL + "/v1/admin/user-management/profile/role/" + role + "/" + "userId/" + _id,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
            data
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        return err.response
    }
}
